var map = {
	"./de-AT.json": "15d3",
	"./de-CH.json": "4031",
	"./de-DE.json": "3f18",
	"./en-GB.json": "60ca",
	"./en-US.json": "4bef",
	"./es-ES.json": "f2f1",
	"./fr-FR.json": "ff10",
	"./it-IT.json": "b97c",
	"./nl-NL.json": "53b1",
	"./pl-PL.json": "13e5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "18bc";